module.exports = __webpack_public_path__ + "img/edit-square.8a0719f6.svg";